'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions, _handleActions2;

import { handleActions } from 'flux-actions';
import Event from 'MeetingsLib/models/Event';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var eventInitialState = Event();
var event = handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_EVENT_DATE, function (state, action) {
  return state.set('dateString', action.date).set('dateTime', null);
}), _defineProperty(_handleActions, ActionTypes.SET_EVENT_DATE_TIME, function (state, action) {
  return state.set('dateTime', action.dateTime);
}), _defineProperty(_handleActions, ActionTypes.BOOKING_TIME_CONFLICT, function (state) {
  return state.set('dateTime', null);
}), _defineProperty(_handleActions, ActionTypes.SET_EVENT_DURATION, function (state, action) {
  return state.set('duration', action.duration).set('dateTime', null);
}), _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var durations = action.payload.bookInfo.customParams.durations;
  var stateWithDuration = state.set('duration', durations.first());
  var formFields = action.payload.bookInfo.customParams.formFields;
  return stateWithDuration.set('formFields', formFields);
}), _handleActions), eventInitialState);
var postResponseInitialState = null;
var postResponse = handleActions((_handleActions2 = {}, _defineProperty(_handleActions2, ActionTypes.MEETING_CREATE_SUCCEEDED, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions2, ActionTypes.MEETING_CREATE_RESET, function () {
  return postResponseInitialState;
}), _defineProperty(_handleActions2, ActionTypes.MEETING_RESCHEDULE_SUCCEEDED, function (state, action) {
  return action.payload;
}), _handleActions2), postResponseInitialState);
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BookingLifecycle();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return state.set('event', event(state.event, action)).set('postResponse', postResponse(state.postResponse, action));
});